<template>
  <div>
    <template>
      <ValidationObserver
        v-slot="{ valid, dirty }"
      >
        <NavTabs
          customClass="capitalize_title"
          :tabs="tabs"
          :activeTab="newActiveTab"
          :massBalanceName="'massBalanceName'"
          :editMode="editMode"
        />

        <SlotScopeWatcher
          :value="dirty"
          @change="$emit('dirtyChanged', dirty)"
        />
        <SlotScopeWatcher
          :value="valid"
          @change="$emit('validChanged', valid)"
        />
      </ValidationObserver>
    </template>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher.vue';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import ImprovementInitiative from './tabs/ImprovmentInitiative.vue';
import CoolingOperatingParameters from './tabs/CoolingOperatingParameters.vue';
import BaselineData from './tabs/BaselineData.vue';
import Summary from './tabs/Summary.vue';

export default {
    name: 'E4SettingFormCooling',
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        NavTabs,
    },
    props: {
        editMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            components: [ImprovementInitiative, CoolingOperatingParameters, BaselineData, Summary],
            componentNames: ['improvementInitiative', 'CoolingOperatingParameters', 'BaselineData', 'Summary'],

            tabs: [],
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'client',
            'e4Config',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
    },

    async created() {
        this.loading = true;
        if (!this.editMode) await this.resetE4Config();
        this.$store.dispatch('changeActiveTab', 0);
        this.populateSample();
        this.tabs = this.tableHeaders();
        this.loading = false;
    },
    methods: {
        ...mapActions({
            setE4Config: 'setE4Config',
            resetE4Config: 'resetE4Config',
        }),
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                name: this.$t(`massBalance.e4Form.titles.${this.componentNames[index]}`),
                component: Vue.component(`tab-${index}`, component),
                disabled: true,
                props: {
                    editMode: this.editMode,
                },
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        populateSample() {
            if (!this.editMode) {
                const ImprovementInitiativeObj = {
                    client: { name: this.client.name, id: this.client.id },
                    site: { name: this.site.name, id: this.site.id },
                    massBalanceName: 'massBalanceName',
                    projectDescription: null,
                    projectName: null,
                    waterSavingsUnit: null,
                };

                this.setE4Config({
                    improvementInitiative: ImprovementInitiativeObj,
                });
            } else {
                const ImprovementInitiativeObj = {
                    client: { name: this.client.name, id: this.client.id },
                    site: { name: this.site.name, id: this.site.id },
                    massBalanceName: 'massBalanceName',
                };

                this.setE4Config({
                    improvementInitiative: ImprovementInitiativeObj,
                });
            }
        },
    },
};
</script>
